













import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { FormQuestion } from "@/store/modules/types";
import { VueEditor } from "vue2-editor";

@Component({
  components: {
    VueEditor,
  },
})
export default class EditorAnswer extends Vue {
  @Prop() readonly question!: FormQuestion;
  text = "";
  toolbar = [
    // [{ font: ["monospace"] }],
    ["bold", "italic", "underline"],
    [{ list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ color: [] }, { background: [] }],
    [{ align: [] }],
  ];
  @Watch("text")
  onTextChanged() {
    this.$emit("answer", this.question.id, this.text);
  }
  mounted() {
    const { answer } = this.question;
    if (answer.value) this.text = answer.value;
  }
}
